// extracted by mini-css-extract-plugin
module.exports = {"main-title":"styles__main-title___1LRpN","icon":"styles__icon___l8bwx","type":"styles__type___23Fvl","description":"styles__description___3beUJ"};